import Http from "@/api/http";

export default {
  /* 考勤管理 */
  /* 原始记录 列表 */
  faceRecordFindByPage: params => {
    return Http.POST("/faceRecord/findByPage", params);
  },
  /* 人员打卡按天--分页查询 */
  findPersonnelFaceRecordDayByPage: params => {
    return Http.POST("/faceRecord/findPersonnelFaceRecordDayByPage", params);
  },
  /* 人员考勤导出 */
  exportPersonnelMonthDayToWages: params => {
    return Http.Export("/faceRecord/exportPersonnelMonthDayToWages", null, params);
  },
};
